import '../about-us/style/scientific-production.scss'

$('.main-header .watch-video').click(function () {
  $('.main-header .video-mask').show()
  $('.main-header .video-mask video').attr('src', 'https://static.qifeizn.com/resources/os/videos/scientific-production-hd.mp4');
})
$('.main-header .video-close').click(function () {
  $('.main-header .video-mask').hide()
  $('.main-header .video-mask video').attr('src', '');
})